import { FigureLabel } from '@/components/ui'

interface PreviewTileProps {
  title: string
  description: string
  caption?: string
  captionRight?: React.ReactNode
  preview: React.ReactNode
}

export const PreviewTile = ({
  title,
  description,
  caption,
  captionRight,
  preview,
}: PreviewTileProps) => {
  return (
    <div className="overflow-hidden rounded-lg border bg-white">
      <div className="flex h-44 flex-col border-b px-6 pt-4 pb-4">
        {(caption || captionRight) && (
          <div className="mb-2 flex items-center justify-between gap-2">
            <FigureLabel className="truncate">{caption}</FigureLabel>
            {captionRight}
          </div>
        )}
        <div className="relative min-h-0 flex-1">{preview}</div>
      </div>
      <div className="space-y-1 px-6 py-4">
        <p className="font-semibold text-blue-7 leading-none tracking-tight">
          {title}
        </p>
        <p className="text-sm leading-snug text-ink-subtle text-pretty">
          {description}
        </p>
      </div>
    </div>
  )
}
